import Client from "./clients/rest";


export default {

    getPriceList(businessId) {
        return Client.get(`business/${businessId}/price-lists `);
    },

    putPriceList(businessId, payload) {
        return Client.put(`business/${businessId}/pricelist`, payload);
    },

};
